
// Helper function to safely parse JSON from SSE events
export const safeJsonParse = (eventData: string, eventType: string): any => {
  try {
    if (!eventData || eventData.trim() === '' || eventData === 'undefined') {
      console.log(`⚠️ [DEBUG] Received empty or undefined data for ${eventType} event, skipping`);
      return null;
    }
    return JSON.parse(eventData);
  } catch (error) {
    console.error(`❌ [DEBUG] Failed to parse JSON for ${eventType} event:`, error);
    console.error(`❌ [DEBUG] Raw event data:`, eventData);
    return null;
  }
};
